"use client";
import { useEffect, useRef } from "react";

export default function TurnstileWidget({
  siteKey = "0x4AAAAAAB72vQiNXbgtFv2s",
  onVerify,
}: {
  siteKey?: string;
  onVerify?: (token: string) => void;
}) {
  const widgetRef = useRef<HTMLDivElement>(null);
  const refreshTimer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!document.querySelector("#cf-turnstile-script")) {
      const script = document.createElement("script");
      script.id = "cf-turnstile-script";
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    (window as any).onTurnstileVerify = (token: string) => {
      onVerify?.(token);
      // Reset refresh timer whenever we get a new token
      if (refreshTimer.current) clearTimeout(refreshTimer.current);
      refreshTimer.current = setTimeout(() => {
        // Re-render Turnstile after 4 minutes (tokens expire at 5 mins)
        if (widgetRef.current) {
          widgetRef.current.innerHTML = "";
          (window as any).turnstile?.render(widgetRef.current, {
            sitekey: siteKey,
            callback: (token: string) => onVerify?.(token),
            theme: "dark",
            size: "flexible",
          });
        }
      }, 240000); // 240 seconds (4 minutes)
    };

    return () => {
      if (refreshTimer.current) clearTimeout(refreshTimer.current);
    };
  }, [onVerify, siteKey]);

  return (
    <div
      ref={widgetRef}
      className="cf-turnstile"
      data-sitekey={siteKey}
      data-callback="onTurnstileVerify"
      data-theme="dark"
      data-size="flexible"
    />
  );
}
